import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import './ScrollIndicator.css';

const ScrollIndicator = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Hide indicator after user scrolls down 100px
      if (window.scrollY > 100) {
        setVisible(false);
      } else {
        setVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ 
      top: window.innerHeight, 
      behavior: 'smooth' 
    });
  };

  if (!visible) return null;

  return (
    <button 
      className="scroll-indicator"
      onClick={handleClick}
      aria-label="Scroll down"
    >
      <ChevronDown size={24} strokeWidth={2} />
    </button>
  );
};

export default ScrollIndicator;
